import { connect } from "react-redux";
import TicketConfirmationPage from "../components/TicketConfirmationPage";
import * as actionsTicket from "../../../_actions/ticket";
import * as actionsDimension from "../../../_actions/dimension";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    //Ticket
    ticketUpdating: Ticket.updating.loading,
    ticketUpdatingError: Ticket.updating.err,
    ticketLoading: Ticket.fetching.loading,
    ticketFetchingError: Ticket.fetching.err,
    ticket: Ticket.data && Ticket.data.result,
    ticketUpdate: Ticket.update && Ticket.update.result,
    //Dimension
    languageListLoading: Dimension.Language.fetching.loading,
    languageList: Dimension.Language.languageList,
    countryListLoading: Dimension.Country.fetching.loading,
    countryList: Dimension.Country.countryList,
    // provinceListLoading: Dimension.Province.fetching.loading,
    // provinceList: Dimension.Province.provinceList,
    referencePlatformListLoading: Dimension.ReferencePlatform.fetching.loading,
    referencePlatformList: Dimension.ReferencePlatform.referencePlatformList,
    requestTypeListLoading: Dimension.RequestType.fetching.loading,
    requestTypeList: Dimension.RequestType.requestTypeList,
    returnReasonListLoading: Dimension.ReturnReason.fetching.loading,
    returnReasonList: Dimension.ReturnReason.returnReasonList,

    //Misc
    language: Misc.Settings.language,
    authToken: Misc.Auth.token,
    authTokenLoading: Misc.Auth.fetching.loading
});

const mapDispatchToProps = dispatch => ({
    updateTicket: (ticketId, ticket) => {
        dispatch(actionsTicket.updateTicket(ticketId, ticket));
    },
    getCountryList: () => {
        dispatch(actionsDimension.getCountryList());
    },
    getProvinceList: () => {
        dispatch(actionsDimension.getProvinceList());
    },
    getReferencePlatformList: () => {
        dispatch(actionsDimension.getReferencePlatformList());
    },
    getRequestTypeList: () => {
        dispatch(actionsDimension.getRequestTypeList());
    },
    getReturnReasonList: () => {
        dispatch(actionsDimension.getReturnReasonList());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketConfirmationPage);
